var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListvehiclestep3Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}.c{fill:#8ac43d;stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-609 -1419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(609 1419)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(621 1431)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M27.5,6a3.009,3.009,0,0,0-3-3H20V6h4.5V9.975L19.28,16.5H14V9H8a6,6,0,0,0-6,6v4.5H5a4.5,4.5,0,0,0,9,0h6.72l6.78-8.475ZM5,16.5V15a3.009,3.009,0,0,1,3-3h3v4.5ZM9.5,21A1.5,1.5,0,0,1,8,19.5h3A1.5,1.5,0,0,1,9.5,21Z",
    transform: "translate(-2 -3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 7.5,
    height: 3,
    transform: "translate(4.5 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.5,11A4.5,4.5,0,1,0,25,15.5,4.494,4.494,0,0,0,20.5,11Zm0,6A1.5,1.5,0,1,1,22,15.5,1.5,1.5,0,0,1,20.5,17Z",
    transform: "translate(5 1)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListvehiclestep3Icon);
export default __webpack_public_path__ + "static/media/listvehiclestep3icon.243c68bc165ee481c1c0f09436ab6035.svg";
export { ForwardRef as ReactComponent };